import { deleteCall, get, patch, post, put } from '.';
import { addPlaybookResource, deletePlaybookResource, getPlaybookResources } from './playbooks';

export const BLANK_TEMPLATE_ID = 1;
export const isBlankTemplateId = (id?: number) => id === BLANK_TEMPLATE_ID;

export const getEventTemplates = () => get(`event-templates`) as Promise<{ templates: Bizly.EventTemplate[] }>;

export const getEventTemplate = (templateId: number | string) =>
    get(`event-templates/${templateId}`) as Promise<{ template: Bizly.EventTemplate }>;

export const createEventTemplate = (template: Partial<Bizly.EventTemplateCreate>) =>
    post(`event-templates`, template) as Promise<{ template: Bizly.EventTemplate }>;

export const updateEventTemplate = (template: Bizly.EventTemplateCreate) =>
    put(`event-templates/${template.id}`, template) as Promise<{ template: Bizly.EventTemplate }>;

export const getEventTemplateTags = () =>
    get(`event-templates/tags`) as Promise<{ tags: { id: number; name: string }[] }>;

export const shareEventTemplate = (templateId: number | string) =>
    post(`event-templates/${templateId}/share`) as Promise<{ template: Bizly.EventTemplate }>;

export const deleteEventTemplate = (templateId: number | string) =>
    deleteCall(`event-templates/${templateId}`) as Promise<{ success: boolean; message: string }>;

export const copyTemplateSchedule = (eventId: number | string, date: Date) =>
    patch(`events/${eventId}/date`, { date }) as Promise<{ event: Bizly.Event }>;

export const getEventTemplatesOptions = () => get(`event-templates/options`) as Promise<Bizly.EventOptions>;

export const getEventTemplateResources = getPlaybookResources;

export const uploadEventTemplateResources = addPlaybookResource;

export const deleteEventTemplateResource = deletePlaybookResource;
